import {
  Dashboard, Group, BusinessOutlined, LockReset, Map,
  Storefront, BrowserUpdated,
  ChatBubbleOutline,
  Email,
  Groups,
  Diversity3,
  NoCrash
} from '@mui/icons-material';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import allowedSidebarItems from '../../utils/accessRoleUtil';
// import CompanyLogo from '../../images/CompanyLogo03';3
// import logo from '../../images/MachoLogo.png';
import logo from '../../images/MachoLogo.jpg';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import SettingsIcon from '@mui/icons-material/Settings';
import TimelineIcon from '@mui/icons-material/Timeline';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import WidgetsIcon from '@mui/icons-material/Widgets';
import PortraitIcon from '@mui/icons-material/Portrait';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PersonIcon from '@mui/icons-material/Person';
import Person2Icon from '@mui/icons-material/Person2';
import GroupsIcon from '@mui/icons-material/Groups';
import SchoolIcon from '@mui/icons-material/School';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import HistoryIcon from '@mui/icons-material/History';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CampaignIcon from '@mui/icons-material/Campaign';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';

const SidebarItems = {
  '': [
    {
    name: 'Dashboard',
    route: 'Dashboard',
    icon: <Dashboard className="sidebarIcon" />,
  },  
    {
    name: 'Dashboard',
    route: 'Dashboardhod',
    icon: <Dashboard className="sidebarIcon" />,
  },  
  {
    name: 'Master',
    route: 'MasterList',
    icon: <GroupAddIcon className="sidebarIcon" />,
    
  },
  {
    name: 'Faculty',
    route: 'FacultyTab',
    icon: <GroupsIcon className="sidebarIcon" />,
    
  },
  {
    name: 'Student',
    route: 'StudentTab',
    icon: <SchoolIcon className="sidebarIcon" />,
    
  },
  {
    name: 'Attendance',
    route: 'AttendenceTab',
    icon: <CoPresentIcon className="sidebarIcon" />,
    
  },
   {
    name: 'Attendance',
    route: 'AttendenceTabFaculty',
    icon: <CoPresentIcon className="sidebarIcon" />,
    
  },
  {
    name: 'Live Attendance',
    route: 'LAttendanceTab',
    icon: <FingerprintIcon className="sidebarIcon" />,
    
  },
  {
    name: 'Report',
    route: 'StudentReportTab',
    icon: <SummarizeIcon className="sidebarIcon" />,
  },
   {
    name: 'SMS Wallet Module',
    route: 'SMSWalletModule',
    icon: <ScheduleSendIcon className="sidebarIcon" />,
  },
  {
    name: 'Report',
    route: 'StudentReportTabFaculty',
    icon: <SummarizeIcon className="sidebarIcon" />,
  },
  {
    name: 'Department',
    route: 'FacultyDepartmentList',
    icon: <AssignmentIndIcon className="sidebarIcon" />,
  },
  {
    name: 'Transfer',
    route: 'StdSemTransferTab',
    icon: <AutorenewIcon className="sidebarIcon" />,
  },
  {
    name: 'History',
    route: 'HistoryTab',
    icon: <HistoryIcon className="sidebarIcon" />,
  },
  {
    name: 'User Management',
    route: 'StudentUserList',
    icon: <PersonIcon className="sidebarIcon" />,
  },
 

   {
   name: 'Attendence Modification',
    route: 'AttendenceModification',
    icon: <BrowserUpdated className="sidebarIcon" />,
  },
 
  // {
  //   name: 'Change Password ',
  //   route: 'ChangePassword',
  //   icon: <LockReset className="sidebarIcon" />,
  // },
  {
    name: 'Gas Cylinder',
    route: 'GasCylinder',
    icon: <Storefront className="sidebarIcon" />,
  },
  // {
  //   name: 'Report',
  //   route: 'AllReportList',
  //   icon: <SummarizeIcon className="sidebarIcon" />,
  // }
  ],
 
  'Profile Settings': [
  {
    name: 'App Version ',
    route: 'AppVersion',
    icon: <BrowserUpdated className="sidebarIcon" />,
  }],
  'Site Details': [{
    name: 'Location',
    route: 'Location',
    icon: <Map className="sidebarIcon" />,
  },
  {
    name: 'Email Config',
    route: 'EmailConfig',
    icon: <Email className="sidebarIcon" />,
  }],
 
  // 'Report Management ':[]
   
};

function DrawerObject() {
  const location = useLocation();
  const currentRoute = location.pathname;
  const [hovered, setHovered] = useState(null);
  const [active, setActive] = useState(currentRoute);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const allowedItems = allowedSidebarItems();
  const sectionCollection = {};
  for (const section in SidebarItems) {
    const allowedCollection = SidebarItems[section].filter((item) => (allowedItems.indexOf(item.route) > -1));

    if (allowedCollection.length > 0) {
      sectionCollection[section] = allowedCollection;
    }
  }

  const handleTabClick = (route) => {
    // Only update the active state if the clicked tab is different from the current active tab
    if (active !== route) {
      setActive(route);
    }
  };

  const handleTabHover = (route) => {
    setHovered(route);
  };

  const handleTabLeave = () => {
    setHovered(null);
  };

  const fetchSideBar = (sideBarObject) => {
    const returnObj = [];
    for (const section in sideBarObject) {
      returnObj.push(<div className="sidebarMenu" key={`${section}01`}>
        <h3 className="sidebarTitle">{section}</h3>
        <ul className="sidebarList">
          {sideBarObject[section].map((item, liIndex) => (
            <NavLink
            to={item.route}
            className={`link ${
              (isMouseOver && (hovered === item.route || active === item.route))
                ? 'link-static-hover'
                : ''
            } ${currentRoute === item.route ? 'active' : ''}`}
            key={item.name + liIndex}
            onClick={() => handleTabClick(item.route)} // Update active state on click
            onMouseEnter={() => handleTabHover(item.route)}
            onMouseLeave={handleTabLeave}
          >
            <li className="sidebarListItem" title={item.name}>
              {item.icon}
              {item.name}
            </li>
          </NavLink>
          ))}
        </ul>
      </div>);
    }
    return returnObj;
  };

  // const [companyLogo, setCompanyLogo] = useState(logo);
  // const { userDetails } = ApplicationStore().getStorage('userDetails');

  // useEffect(() => {
  //   if (userDetails.companyLogo) {
  //     // setCompanyLogo(`http://wisething.in/Aqms/blog/public/${userDetails.companyLogo}?${new Date().getTime()}`);
  //   }
  // }, []);

  return (
    <div className="block" >
      <div className="wrapper" style={{ display: 'flex' }}>
        <div className="items">
          <div className="">
            <Link to="Dashboard">
              {/* <img
                src={logo}
                alt=""
                className="avatar"
                style={{ width: 200, height: '10vh' }}
              /> */}
            </Link>
          </div>
        </div>
      </div>
      <div className="sidebar" style={{ top: 0 }}>
        <div className="sidebarWrapper">
          {fetchSideBar(sectionCollection)}
        </div>
      </div>
    </div>
//     <div className="sidebar-container">
//   <div className="header-wrapper" style={{ display: 'flex' }}>
//     <div className="logo-container">
//       <Link to="Dashboard">
//         {/* Uncomment when you have the logo */}
//         {/* <img
//           src={logo}
//           alt="Company Logo"
//           className="logo-image"
//           style={{ width: 200, height: '10vh' }}
//         /> */}
//       </Link>
//     </div>
//   </div>
  
//   <div className="sidebar">
//     <div className="sidebar-content">
//       {fetchSideBar(sectionCollection)}
//     </div>
//   </div>
// </div>
  );
}

export { DrawerObject, SidebarItems };
